import ControlButton from '../controlButton.js';

import * as btnStyles from '../btn.module.scss';

export default class NewGameBtn extends ControlButton {
  constructor() {
    super({ text: 'NEW GAME' });

    this.addClasses(btnStyles.btnHidden);
    window.addEventListener('mouseup', this.handleRestart.bind(this));
    window.addEventListener('changestart', this.handleChangeStart.bind(this));
  }

  /**
   * Sets the state's start property. Restarts the game.
   * @returns {void}
   * @private
   */
  handleRestart() {
    if (this.isPressed && !this.state.block) {
      this.state.start = false;
    }
  }

  /**
   * Handles changes in the state's start property.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleChangeStart(e) {
    const { start } = e.detail;

    if (start) this.removeClasses(btnStyles.btnHidden);
    else this.addClasses(btnStyles.btnHidden);
  }
}
